import { Component, EventEmitter, Input, OnInit, OnDestroy, Output, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { UtilitiesService } from '../../core/services/utilities.service';
import { UserService } from '../../core/services/data/user.service';
import { SiteAdvertsService } from '../../core/services/data/site-adverts.service';
import { ModalService } from '../../core/services/modal.service';
import { AnalyticsService } from '../../core/services/analytics.service';
import { PosthogService } from '../../core/services/posthog.service';
import { PurchaseProcessService } from '../../core/services/data/purchase-process.service';

@Component({
	selector: 'app-pub-date-picker',
	templateUrl: './pub-date-picker.component.html',
	styleUrls: ['./pub-date-picker.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class PubDatePickerComponent implements OnInit, OnDestroy {
	public injectObj;

	UserObj: string;

	@Input() set siteAdvert(siteAdvert: any) {
		this._siteAdvert = siteAdvert;
		this.inProgress = true;
		this.siteAdvertDays = [];
		if (this._siteAdvert) {
			this.sas.getInventory(this._siteAdvert).subscribe((data: any) => {
				this.siteAdvertDays = data.finalDates;

				if (this.isGuestOrFreeMember()) {
					if (!this.uss.isMember()) {
						this.injectObj = { UserObj: 'free' };
					} else {
						this.injectObj = { UserObj: 'member' };
					}

					this.injectKeyValueInArray(this.siteAdvertDays, this.injectObj).then();
				}
			});
		} else {
			const today = moment();
			while (parseInt(today.format('YYYYMMDD'), 10) <= this._availableTo) {
				this.siteAdvertDays.push({ pubDate: parseInt(today.format('YYYYMMDD'), 10), soldOut: false });
				today.add(1, 'd');
			}
		}
	}

	@Input() set availableTo(availableTo: any) {
		this._availableTo = availableTo;
		if (!this._siteAdvert) {
			const today = moment();
			while (parseInt(today.format('YYYYMMDD'), 10) <= this._availableTo) {
				this.siteAdvertDays.push({ pubDate: parseInt(today.format('YYYYMMDD'), 10), soldOut: false });
				today.add(1, 'd');
			}
		}
	}

	@Input() move;

	@Output() unavailableToFree = new EventEmitter();

	public siteSlug: string;

	public siteAdvertSlug: string;

	public moment = moment;

	public today;

	public inProgress = false;

	public siteAdvertDays = [];

	public text;

	private _availableTo;

	private user;

	private _siteAdvert;

	private route$;

	constructor(
		private us: UtilitiesService,
		private uss: UserService,
		private sas: SiteAdvertsService,
		private ms: ModalService,
		private route: ActivatedRoute,
		private router: Router,
		private analyticsService: AnalyticsService,
		private posthogService: PosthogService,
		private purchaseProcessService: PurchaseProcessService,
	) { }

	ngOnInit() {
		this.route$ = this.route.params.subscribe(({ siteSlug, siteAdvertSlug }) => {
			this.siteSlug = siteSlug;
			this.siteAdvertSlug = siteAdvertSlug;
		});

		this.moment = this.us.momentInstance;
		this.today = parseInt(this.moment().format('YYYYMMDD'), 10);
		this.uss.fetchUser().then((data: any) => {
			this.user = data;
		}, () => {
			this.user = null;
		});
	}

	ngOnDestroy(): void {
		this.route$.unsubscribe();
	}

	isGuestOrFreeMember() {
		return this.user === null || this.uss.isFreeMember();
	}

	selectDate(date, soldOut, role) {
		if (role === 'free') {
			this.unavailableToFree.emit();
			return;
		}
		if (soldOut) return;
		const _pubDate = date.toString();
		this.analyticsService.trackSelectDate(_pubDate, this.siteSlug);

		const price = this.purchaseProcessService.isDiscounted()
			? this.purchaseProcessService.discountedPrice()
			: this.purchaseProcessService.regularPrice();
		this.posthogService.capture(this.posthogService.DATE_SELECTED, {
			product_type: 'featuredBook',
			product_id: this._siteAdvert,
			product_name: this.purchaseProcessService.siteAdvert?.name,
			price,
			site: this.purchaseProcessService.site?.abbreviatedName,
			selected_date: moment(_pubDate, 'YYYYMMDD').toISOString(),
		});

		this.router.navigate([_pubDate], { relativeTo: this.route });
	}

	/**
	 * I have no idea what this is but it's hideous,
	 * unsafe array index access everywhere with no regards
	 * for undefined values or out of bounds/negative indexes.
	 */
	injectKeyValueInArray(array, keyValues) {
		return new Promise((resolve, reject) => {
			const lastDay = array[array.length - 1];
			const penultimate = array[array.length - 2];
			if (!lastDay || !penultimate) {
				resolve(array);
			}

			const fetch = moment(lastDay.pubDate, 'YYYYMMDD').diff(moment(penultimate.pubDate, 'YYYYMMDD'), 'week');
			let arrayforCommonUser;
			if (fetch >= 1) {
				arrayforCommonUser = array.length - 3;
			} else {
				arrayforCommonUser = array.length - 15;
			}

			let date = moment(lastDay.pubDate, 'YYYYMMDD').subtract(14, 'days');
			const last14days = [];
			for (let day = 0; day < 14; day++) {
				date = date.add(1, 'day');
				// eslint-disable-next-line radix
				const dayNumber = parseInt(date.format('YYYYMMDD'));

				last14days.push(dayNumber);
			}

			if (!array.length) return resolve(array);
			array.forEach((object, index) => {
				if (index > arrayforCommonUser) {
					for (const key in keyValues) {
						// eslint-disable-next-line no-prototype-builtins
						if (keyValues.hasOwnProperty(key) && last14days.includes(object.pubDate)) {
							object[key] = keyValues[key];
						}
					}
				}
			});

			return resolve(array);
		});
	}
}
